import React from 'react';
export const DigitalIcon = class DigitalIcon extends React.Component {
  render() {
    return (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="56.000000pt" height="56.000000pt" viewBox="0 0 56.000000 56.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,56.000000) scale(0.100000,-0.100000)"
          fill="#000000" stroke="none">
          <path d="M83 553 c-15 -6 -17 -49 -3 -58 20 -12 11 -55 -14 -65 -13 -4 -33
          -21 -46 -37 -26 -33 -23 -92 7 -125 18 -20 18 -20 23 8 4 25 10 29 43 32 43 4
          64 -9 69 -41 4 -20 6 -19 24 10 22 38 34 38 53 -3 14 -28 29 -44 43 -44 9 0
          38 30 38 40 0 16 -33 41 -47 36 -39 -15 -100 76 -73 109 17 21 25 19 40 -10
          16 -31 23 -31 35 -2 8 17 20 23 52 25 l41 3 26 -57 c23 -51 25 -59 11 -67 -35
          -19 -55 -52 -55 -88 0 -52 -21 -67 -59 -40 -34 25 -97 28 -127 6 -12 -8 -27
          -28 -34 -45 -9 -21 -19 -30 -36 -30 -13 0 -24 4 -24 9 0 16 -40 23 -55 11 -19
          -16 -19 -35 1 -55 15 -14 18 -14 40 0 31 20 63 19 71 -2 3 -10 13 -26 22 -36
          15 -18 16 -18 21 5 5 20 12 23 55 23 45 0 50 -2 53 -23 3 -23 4 -23 23 -6 10
          9 19 23 19 31 0 27 45 0 64 -39 14 -27 54 -31 69 -6 14 22 -7 48 -40 48 -22 0
          -83 25 -83 34 0 3 -3 11 -6 19 -3 10 3 20 16 27 18 10 24 8 36 -7 13 -17 13
          -17 14 4 0 25 27 43 64 43 30 0 57 -25 50 -45 -4 -8 -2 -15 3 -15 15 0 43 57
          43 88 0 39 -41 88 -80 97 -43 9 -65 54 -50 100 11 35 12 35 41 20 16 -9 29
          -22 29 -29 0 -7 6 -19 14 -25 19 -16 56 3 56 28 0 24 -25 45 -45 38 -22 -9
          -83 20 -90 42 -3 11 -20 32 -38 47 -55 46 -133 21 -157 -51 -16 -48 -53 -70
          -91 -55 -32 14 -41 53 -14 64 18 7 20 37 3 54 -13 13 -24 14 -45 5z m276 -52
          c13 -24 -8 -55 -34 -50 -28 6 -42 34 -26 53 18 22 48 20 60 -3z m-229 -116
          c20 -25 8 -50 -25 -50 -31 0 -43 20 -31 51 7 18 40 18 56 -1z m351 -127 c10
          -18 8 -24 -10 -39 -25 -21 -48 -16 -56 12 -14 44 44 67 66 27z m-233 -100 c17
          -17 15 -43 -4 -59 -31 -26 -70 25 -44 56 15 18 32 19 48 3z"/>
          <path d="M310 485 c0 -10 7 -15 18 -13 21 4 19 22 -2 26 -10 2 -16 -3 -16 -13z" />
          <path d="M87 374 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z" />
          <path d="M434 249 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16
-11z"/>
          <path d="M210 129 c0 -24 23 -21 28 4 2 10 -3 17 -12 17 -10 0 -16 -9 -16 -21z" />
          <path d="M290 387 c0 -28 32 -42 61 -27 30 17 16 45 -24 48 -33 3 -37 1 -37
-21z"/>
          <path d="M70 266 c0 -30 14 -40 46 -32 17 5 24 13 24 31 0 22 -4 25 -35 25
-30 0 -35 -3 -35 -24z"/>
          <path d="M414 156 c-12 -30 4 -47 38 -44 28 2 33 7 33 28 0 21 -5 26 -33 28
-22 2 -34 -2 -38 -12z"/>
          <path d="M197 54 c-4 -4 -7 -18 -7 -31 0 -20 5 -23 36 -23 33 0 35 2 32 27 -2
21 -9 29 -28 31 -14 2 -29 0 -33 -4z"/>
        </g>
      </svg>
    );
  }
}